// Un resultado incierto no se desbloquea por una lectura vacía ni por cambiar variante.
// El registro vive por producto y pestaña; sessionStorage conserva el bloqueo al recargar.
if (!window.CollinoProductAddRecovery) {
  window.CollinoProductAddRecovery = (() => {
    const blocked = new Set();
    const key = root => root.dataset?.productHandle;
    const isUncertain = root => {
      const handle = key(root);
      if (!handle) return false;
      if (blocked.has(handle)) return true;
      try { return window.sessionStorage?.getItem('collino-add-uncertain:' + handle) === '1'; } catch { return false; }
    };
    const markUncertain = root => {
      const handle = key(root);
      if (!handle) return;
      blocked.add(handle);
      try { window.sessionStorage?.setItem('collino-add-uncertain:' + handle, '1'); } catch { /* El candado en memoria sigue activo. */ }
    };
    return { isUncertain, markUncertain };
  })();
}

if (!customElements.get('variant-selects')) {

  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.productWrapper = this.closest('.thb-product-detail');
      this.other = Array.from(this.productWrapper?.querySelectorAll('variant-selects') || []).filter((selector) => {
        return selector !== this && selector.dataset.section === this.dataset.section;
      });
      this.productSlider = this.productWrapper?.querySelector('.product-images');
      this.hideVariants = this.dataset.hideVariants === 'true';
      this.renderController = null;
      this.addEventListener('click', (event) => {
        if (!event.target.closest('[data-variant-retry]') || !this.currentVariant) return;
        event.preventDefault();
        this.retryRequested = true;
        this.renderProductInfo();
      });
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();
    }

    disconnectedCallback() {
      this.renderController?.abort();
      this.purchaseNodes = null;
    }

    setPurchaseState(state) {
      const purchase = this.productWrapper?.querySelector('[data-product-purchase]');
      if (!purchase) return;
      const canBuy = state === 'ready' && this.currentVariant?.available && Number(this.currentVariant.price) > 0 && !window.CollinoProductAddRecovery.isUncertain(this);
      purchase.dataset.variantState = state;
      purchase.setAttribute('aria-busy', String(state === 'loading'));
      const status = this.querySelector('[data-variant-status]');
      if (status) status.textContent = state === 'loading' ? 'Actualizando opción…' : state === 'unavailable' ? 'Esta combinación no está disponible. Elegí otra opción.' : '';
      const input = purchase.querySelector('input[name="id"]');
      if (input) input.disabled = !canBuy;
      purchase.querySelectorAll('[data-dynamic-checkout]').forEach((checkout) => {
        checkout.hidden = !canBuy;
        checkout.toggleAttribute('inert', !canBuy);
      });
      purchase.querySelectorAll('[data-cart-redirect]').forEach((button) => {
        button.disabled = !canBuy;
      });
      if (state !== 'ready') this.toggleAddButton(true, '', false);
      this.productWrapper.querySelector('[data-pdp-price]')?.classList.toggle('visibility-hidden', state !== 'ready');
      this.getSectionsToRender().filter((id) => id.startsWith('price-')).forEach((id) => {
        document.getElementById(id)?.classList.toggle('visibility-hidden', state !== 'ready');
      });
    }

    showVariantError(show) {
      const error = this.querySelector('[data-variant-error]');
      if (error) error.hidden = !show;
    }

    updatePurchaseContent(html) {
      const target = this.productWrapper?.querySelector('[data-product-purchase-content]');
      const source = html.querySelector('[data-product-purchase-content]');
      if (!target || !source) return;
      const wasConsult = !!target.querySelector('[data-product-consult]');
      const isConsult = !!source.querySelector('[data-product-consult]');
      // Preserve the existing native form and app/gift-card fields for paid-to-paid changes.
      if (wasConsult && isConsult) {
        const currentLink = target.querySelector('[data-product-consult] a[href]');
        const nextLink = source.querySelector('[data-product-consult] a[href]');
        if (currentLink && nextLink) currentLink.href = nextLink.href;
        return;
      }
      if (wasConsult === isConsult) return;
      if (!wasConsult) {
        // Retain native nodes, including app state, gift fields and file selections.
        this.purchaseNodes = Array.from(target.childNodes);
        target.innerHTML = source.innerHTML;
      } else if (this.purchaseNodes) {
        target.replaceChildren(...this.purchaseNodes);
        this.purchaseNodes = null;
      } else {
        target.innerHTML = source.innerHTML;
      }
    }

    onVariantChange() {
      this.retryRequested = false;
      this.updateOptions();
      this.updateMasterId();
      this.renderController?.abort();
      this.setPurchaseState('loading');
      this.showVariantError(false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
        this.setPurchaseState('unavailable');
      } else {
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
      }

      this.updateOther();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked').value);
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.textContent = this.options[i];
        }
      });
    }
    updateMasterId() {
      if (!this.getVariantData()) {
        return;
      }
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value='${option}']`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }


updateMedia() {
  if (!this.currentVariant) return;
  if (!this.currentVariant.featured_media) return;

  let thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');

  this.setActiveMedia(`#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`,
                      `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`,
                      this.productSlider,
                      thumbnails);
}

setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
  if (!productSlider) return;
  let activeMedia = productSlider.querySelector(mediaId);

  if (productSlider.flkty && this.hideVariants) {

    let previousActiveSlide = productSlider.querySelector('.product-images__slide.is-initial-selected');
    if (previousActiveSlide) {
      previousActiveSlide.classList.remove('is-initial-selected');
    }

    let previousActiveThumb = thumbnails?.querySelector('.product-thumbnail.is-initial-selected');
    if (previousActiveThumb) {
      previousActiveThumb.classList.remove('is-initial-selected');
    }

    [].forEach.call(productSlider.querySelectorAll('.product-images__slide-item--variant'), function (el) {
      el.classList.remove('is-active');
    });

    // General images, videos and 3D models remain available, as in the Liquid render.
    [].forEach.call(thumbnails?.querySelectorAll('.product-thumbnail.product-images__slide-item--variant') || [], function (el) {
      el.classList.remove('is-active');
    });

    if (activeMedia) {
      activeMedia.classList.add('is-active');
      activeMedia.classList.add('is-initial-selected');
    }

    let activeThumb = thumbnails?.querySelector(thumbId);
    if (activeThumb) {
      activeThumb.classList.add('is-active');
      activeThumb.classList.add('is-initial-selected');
    }

    if (productSlider.reInit) {
      productSlider.reInit(this.imageSetIndex);
    }

    if (productSlider.flkty) {
      productSlider.flkty.selectCell(mediaId, false, true);
    }

  } else if (productSlider.flkty) {
    // A variant chooses its exact image. Do not animate through unrelated
    // gallery cells; swipes and thumbnail navigation retain their transitions.
    productSlider.flkty.selectCell(mediaId, false, true);
  }
  productSlider.syncThumbnailState?.();
}






    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      const url = new URL(window.location.href);
      url.searchParams.set('variant', this.currentVariant.id);
      window.history.replaceState({}, '', url.href);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = [
        document.getElementById(`product-form-${this.dataset.section}`),
        ...Array.from(this.productWrapper?.querySelectorAll('form.installment, form[id^="product-form-installment-"]') || [])
      ].filter(Boolean);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        if (!input) return;
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = this.productWrapper?.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.clearAvailability();
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) {
        if (window.CollinoProductAddRecovery.isUncertain(productForm)) productForm.showUnconfirmedAdd();
        else productForm.handleErrorMessage();
      }
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--mobile`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }

    updateQuantityContent(destination, source) {
      const input = destination.querySelector('input[name="quantity"]');
      const nextInput = source.querySelector('input[name="quantity"]');
      if (!input || !nextInput) {
        destination.innerHTML = source.innerHTML;
        return;
      }
      // Keep the live input/value/focus; only Shopify's variant rules change.
      ['min', 'max', 'step'].forEach((name) => {
        const value = nextInput.getAttribute(name);
        if (value === null) input.removeAttribute(name);
        else input.setAttribute(name, value);
      });
      input.setCustomValidity('');
      const selector = destination.querySelector('quantity-selector');
      if (selector) {
        selector.step = Number(input.getAttribute('step')) || 1;
        selector.normalizeInput?.();
      }
    }

    renderProductInfo() {
      if (!this.currentVariant) return Promise.resolve();
      this.setPurchaseState('loading');
      this.showVariantError(false);
      const sections = this.getSectionsToRender();
      const requestedVariantId = this.currentVariant.id;

      if (this.renderController) this.renderController.abort();
      this.renderController = new AbortController();
      const controller = this.renderController;
      let timedOut = false;
      const timeout = setTimeout(() => {
        timedOut = true;
        controller.abort();
      }, 15000);

      const productView = this.productWrapper?.dataset.productView === 'quick-view' ? '&view=quick-view' : '';
      // Section Rendering must stay on the unpublished theme used by the preview.
      const previewTheme = window.Shopify?.theme;
      const previewThemeParam = previewTheme?.role === 'unpublished' && Number.isSafeInteger(previewTheme.id)
        ? `&preview_theme_id=${previewTheme.id}` : '';
      return fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.section}${productView}${previewThemeParam}`, {
        cache: 'no-store',
        signal: controller.signal
      })
        .then((response) => {
          if (!response.ok) throw new Error(`Variant request failed: ${response.status}`);
          return response.text();
        })
        .then((responseText) => {
          if (controller.signal.aborted || !this.isConnected || this.currentVariant?.id !== requestedVariantId) return;
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const variantJSON = html.querySelector('variant-selects [type="application/json"], variant-radios [type="application/json"]');
          const variants = variantJSON ? JSON.parse(variantJSON.textContent) : null;
          const variant = Array.isArray(variants) ? variants.find((item) => item.id === requestedVariantId) : null;
          if (!variant || typeof variant.available !== 'boolean' || !Number.isFinite(variant.price)) {
            throw new Error('Missing variant state');
          }
          const purchase = this.productWrapper?.querySelector('[data-product-purchase-content]');
          if (purchase && !html.querySelector('[data-product-purchase-content]')) throw new Error('Missing purchase content');
          const price = this.productWrapper?.querySelector('[data-pdp-price]');
          const nextPrice = html.querySelector('[data-pdp-price]');
          if (price && !nextPrice) throw new Error('Missing price content');
          // Stock and prices can change after the initial page was loaded.
          this.variantData = variants;
          this.currentVariant = variant;
          this.setDisabled();
          this.updatePurchaseContent(html);
          if (price && nextPrice) {
            price.innerHTML = nextPrice.innerHTML;
            price.dataset.sinPrecio = nextPrice.dataset.sinPrecio;
          }

          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) {
              if (id.startsWith('quantity-')) this.updateQuantityContent(destination, source);
              else destination.innerHTML = source.innerHTML;
            }

            if (id.includes('price') && destination) {
              destination.classList.remove('visibility-hidden');
            }

          });
          this.setPurchaseState('ready');
          this.updateVariantInput();
          if (this.retryRequested) {
            this.querySelector('select, input:checked')?.focus();
            this.retryRequested = false;
          }
          if (window.Shopify?.PaymentButton?.init) window.Shopify.PaymentButton.init();
          const isConsultVariant = Number(this.currentVariant.price) <= 0;
          this.toggleAddButton(
            !this.currentVariant.available || isConsultVariant,
            isConsultVariant ? 'Consultar precio' : window.theme.variantStrings.soldOut
          );

        })
        .catch((error) => {
          if ((error.name === 'AbortError' && !timedOut) || this.renderController !== controller ||
            !this.isConnected || this.currentVariant?.id !== requestedVariantId) return;
          this.setPurchaseState('error');
          this.showVariantError(true);
        })
        .finally(() => {
          clearTimeout(timeout);
          if (this.renderController === controller) this.renderController = null;
        });
    }

    getSubmitButtons() {
      const sectionId = this.dataset.section;
      return document.querySelectorAll(
        `product-form[data-section="${sectionId}"] .single-add-to-cart-button, ` +
        `product-add-to-cart-sticky[data-section="${sectionId}"] .single-add-to-cart-button`
      );
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;
      if (window.CollinoProductAddRecovery.isUncertain(this)) {
        disable = true;
        productForm.closest('product-form')?.showUnconfirmedAdd();
      }

      const productTemplate = productForm.closest('.product-form').getAttribute('template');
      const submitButtons = this.getSubmitButtons();

      if (!submitButtons) return;
      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) submitButtonText.textContent = text;
          // La clase la pone/saca SOLO quien pide modifyClass. onVariantChange()
          // llama con false mientras resuelve la variante: es un estado de paso
          // y no queremos que el boton parpadee en gris.
          if (modifyClass) submitButton.classList.add('sold-out');
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');

          // Esto faltaba y es el bug: al elegir una variante sin stock el boton
          // queda con .sold-out, que en product-add-to-cart.liquid es
          // opacity:0.5 + cursor:not-allowed. Al volver a una variante CON
          // stock se quitaba el atributo disabled pero no la clase, asi que el
          // boton quedaba clickeable pero pintado de gris y con el cursor de
          // bloqueado: parecia muerto y nadie lo tocaba.
          if (modifyClass) submitButton.classList.remove('sold-out');

          if (productTemplate?.includes('pre-order')) {
            submitButtonText.textContent = window.theme.variantStrings.preOrder;
          } else {
            submitButtonText.textContent = window.theme.variantStrings.addToCart;
          }

        }
      });
    }

    setUnavailable() {
      const submitButtons = this.getSubmitButtons();
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_mobile = document.getElementById(`price-${this.dataset.section}--mobile`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        // Chequeaba submitButton, que en este punto no puede ser nulo (viene del
        // forEach). El que puede faltar es el span de texto, y si faltaba la
        // linea de abajo tiraba TypeError y cortaba el resto del metodo.
        if (!submitButtonText) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
      if (price_mobile) price_mobile.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      const variant_data = this.getVariantData();


      if (variant_data) {

        let selected_options = false;
        if (this.currentVariant) {
          selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });
        } else {
          // Sin variante valida hay que usar lo que el visitante ELIGIO, que es
          // exactamente lo que updateOptions() dejo en this.options.
          //
          // Antes se buscaba la primera variante que coincidiera en option1 y se
          // tomaba SU option2 como si fuera lo elegido: cuando la combinacion no
          // existia, se inventaba un valor. Medido en volante-spider-m6-330, que
          // tiene ACERO en sus 3 colores pero ALUMINIO solo en DARK: al elegir
          // ALUMINIO + ROJO FLUOR se armaba [ALUMINIO, DARK], y mas abajo la
          // regla que marca lo elegido como no disponible terminaba bloqueando
          // DARK, o sea la unica combinacion que SI existe. El visitante veia
          // deshabilitada la opcion buena y habilitada la que no anda.
          //
          // De paso: aquello asumia exactamente dos opciones. Un producto con
          // tres (talle/color/material) quedaba mal armado.
          selected_options = this.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });
        }
        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);


        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = true;
                } else {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll('input').length) {
              fieldset.querySelectorAll('input').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        });

      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;
        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }

      let setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productWrapper.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`),
        selected_set_thumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);
      if (this.hideVariants) {
        this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_images.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });

        this.productWrapper.querySelectorAll('.product-thumbnail').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_thumbs.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });
      }

    }

    createAvailableOptionsTree(variant_data, selected_options) {
      return variant_data.reduce((options, variant) => {

        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Resolve each option against its preceding selections only. Requiring
          // later values to match makes sparse three-option products impossible
          // to reach through dropdowns (both later controls become disabled).
          const position = Number(index.replace('option', ''));
          const matchesPreviousOptions = selected_options
            .filter((option) => Number(option.index.replace('option', '')) < position)
            .every((option) => variant[option.index] === option.value);

          if (variant.available && matchesPreviousOptions) {
            entry.isUnavailable = false;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define('variant-selects', VariantSelects);

  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-slider')) {
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', this.setupProductGallery);
    }
    connectedCallback() {
      if (this.flkty) return;
      this.product_container = this.closest('.thb-product-detail');
      if (!this.product_container) return;
      this.thumbnail_container = this.product_container.querySelector('.product-thumbnail-container');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      this.setOptions();
      this.init();
    }
    setOptions() {
      this.hide_variants = this.dataset.hideVariants == 'true';
      this.thumbnails = this.thumbnail_container?.querySelectorAll('.product-thumbnail') || [];
      this.prev_button = this.querySelector('.flickity-prev');
      this.next_button = this.querySelector('.flickity-next');
      this.toggleAttribute('data-gallery-multiple', this.querySelectorAll('.product-images__slide.is-active').length > 1);
      this.options = {
        cellAlign: this.hasAttribute('data-mobile-gallery') ? 'left' : 'center',
        wrapAround: true,
        pageDots: false,
        contain: true,
        adaptiveHeight: true,
        initialIndex: '.is-initial-selected',
        prevNextButtons: false,
        fade: false,
        cellSelector: '.product-images__slide.is-active',
        dragThreshold: 10
      };
    }
    init() {
      this.flkty = new Flickity(this, this.options);

      this.selectedIndex = this.flkty.selectedIndex;

      this.setupEvents();

      this.setupProductGallery();
    }
    reInit(imageSetIndex) {
      this.cancelPendingZoom();
      this.flkty.destroy();

      this.setOptions();

      this.flkty = new Flickity(this, this.options);

      this.setupEvents();

      this.selectedIndex = this.flkty.selectedIndex;
    }
    setupEvents() {
      const _this = this;
      this.eventsController?.abort();
      this.eventsController = new AbortController();
      const signal = this.eventsController.signal;
      this.prev_button?.addEventListener('click', () => this.flkty.previous(), { signal });
      this.next_button?.addEventListener('click', () => this.flkty.next(), { signal });
      this.thumbnail_container?.addEventListener('click', (event) => {
        const thumbnail = event.target.closest('[data-product-thumbnail]');
        if (!thumbnail || !this.thumbnail_container.contains(thumbnail) || !thumbnail.classList.contains('is-active')) return;
        this.flkty.selectCell('#' + thumbnail.dataset.mediaTarget);
        this.syncThumbnailState();
      }, { signal });
      this.syncThumbnailState();
      this.flkty.on('dragStart', () => this.cancelPendingZoom());
      this.video_containers.forEach((container) => {
        container.querySelector('button')?.addEventListener('click', function () {
          container.setAttribute('hidden', '');
        }, { signal });
      });
      this.flkty.on('settle', function (index) {
        _this.selectedIndex = index;
      });
      this.flkty.on('change', (index) => {
        this.cancelPendingZoom();
        const previous_slide = this.flkty.cells[_this.selectedIndex]?.element;
        const previous_media = previous_slide?.querySelector('.product-single__media');
        this.syncThumbnailState(true);
        if (!previous_media) return;

        if (previous_media.classList.contains('product-single__media-external-video')) {
          // Origen exacto del iframe para postMessage (nunca '*').
          const video_iframe = previous_media.querySelector('iframe');
          const video_origin = (fallback) => {
            if (!video_iframe || !video_iframe.src) return fallback;
            try {
              return new URL(video_iframe.src, window.location.href).origin;
            } catch (e) {
              return fallback;
            }
          };
          if (video_iframe && previous_media.dataset.provider === 'youtube') {
            video_iframe.contentWindow.postMessage(JSON.stringify({
              event: "command",
              func: "pauseVideo",
              args: ""
            }), video_origin('https://www.youtube.com'));
          } else if (video_iframe && previous_media.dataset.provider === 'vimeo') {
            video_iframe.contentWindow.postMessage(JSON.stringify({
              method: "pause"
            }), video_origin('https://player.vimeo.com'));
          }
          previous_media.querySelector('.product-single__media-external-video--play').removeAttribute('hidden');
        } else if (previous_media.classList.contains('product-single__media-native-video')) {
          previous_media.querySelector('video').pause();
        }

      });


    }
    syncThumbnailState(scroll = false) {
      const counter = this.querySelector('[data-product-media-count]');
      if (counter) {
        const total = this.flkty?.cells?.length || 0;
        counter.hidden = total < 2;
        counter.textContent = total > 1 ? (this.flkty.selectedIndex + 1) + ' / ' + total : '';
      }
      const selectedId = this.flkty?.selectedElement?.id;
      let active;
      this.thumbnails?.forEach((thumbnail) => {
        const selected = thumbnail.dataset.mediaTarget === selectedId;
        thumbnail.classList.toggle('is-initial-selected', selected);
        thumbnail.setAttribute('aria-pressed', String(selected));
        if (selected) active = thumbnail;
      });
      if (!scroll || !active) return;
      requestAnimationFrame(() => {
        if (!active.isConnected || !active.offsetParent) return;
        const parent = active.parentElement;
        parent.scrollTo({
          left: active.offsetLeft - parent.clientWidth / 2 + active.clientWidth / 2,
          top: active.offsetTop - parent.clientHeight / 2 + active.clientHeight / 2,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      });
    }
    disconnectedCallback() {
      this.eventsController?.abort();
      this.viewerController?.abort();
      this.activeZoom?.close();
      this.zoomController?.abort();
      this.cancelPendingZoom?.();
      this.flkty?.destroy();
      this.flkty = null;
    }
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }
      this.setEventListeners();
    }
    buildItems() {
      this.activeImages = Array.from(this.querySelectorAll('.product-images__slide.is-active .product-single__media-image'));

      return this.activeImages.map((item, index) => {
        // PhotoSwipe contains images only; video/model cells are not indexes in this list.

        let activelink = item.querySelector('.product-single__media-zoom');

        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h
        };
      });
    }
    setEventListeners() {
      this.links = this.querySelectorAll('.product-single__media-zoom');
      this.pswpElement = document.querySelectorAll('.pswp')[0];
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector('.product-images__slide.is-selected'),
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };


      this.zoomController?.abort();
      this.zoomController = new AbortController();
      this.links.forEach((link => {
        link.addEventListener('click', (e) => this.zoomClick(e, link), { signal: this.zoomController.signal });
        ['pointerenter', 'focus'].forEach((eventName) => {
          link.addEventListener(eventName, () => this.loadZoomAssets().catch(() => {}), {
            signal: this.zoomController.signal, passive: true
          });
        });
      }));
    }
    loadZoomAssets() {
      if (typeof PhotoSwipe !== 'undefined' && typeof PhotoSwipeUI_Default !== 'undefined') {
        return Promise.resolve();
      }
      if (ProductSlider.zoomAssetsPromise) return ProductSlider.zoomAssetsPromise;
      const sources = [
        [this.pswpElement?.dataset.photoswipeSrc, 'PhotoSwipe'],
        [this.pswpElement?.dataset.photoswipeUiSrc, 'PhotoSwipeUI_Default']
      ];
      if (sources.some(([src]) => !src)) return Promise.reject(new Error('Missing zoom assets'));
      // Both files download together; async=false preserves core -> UI execution.
      ProductSlider.zoomAssetsPromise = Promise.all(sources.map(([src, globalName]) => {
        if (window[globalName]) return Promise.resolve();
        return new Promise((resolve, reject) => {
          const absoluteSrc = new URL(src, document.baseURI).href;
          const existing = Array.from(document.scripts).find((script) => script.src === absoluteSrc);
          const script = existing || document.createElement('script');
          const finish = (error) => {
            clearTimeout(timeout);
            script.removeEventListener('load', onLoad);
            script.removeEventListener('error', onError);
            if (error) {
              if (!existing) script.remove();
              reject(error);
            } else resolve();
          };
          const onLoad = () => finish(window[globalName] ? null : new Error('Invalid zoom asset'));
          const onError = () => finish(new Error('Zoom asset unavailable'));
          const timeout = setTimeout(onError, 20000);
          script.addEventListener('load', onLoad, { once: true });
          script.addEventListener('error', onError, { once: true });
          if (!existing) {
            script.async = false;
            script.src = src;
            document.head.appendChild(script);
          }
        });
      })).catch((error) => {
        ProductSlider.zoomAssetsPromise = null;
        throw error;
      });
      return ProductSlider.zoomAssetsPromise;
    }
    cancelPendingZoom() {
      if (!this.pendingZoom) return;
      this.pendingZoom.link.removeAttribute('aria-busy');
      this.pendingZoom.controller.abort();
      this.pendingZoom = null;
    }
    zoomClick(e, link) {
      e.preventDefault();
      if (typeof PhotoSwipe !== 'undefined' && typeof PhotoSwipeUI_Default !== 'undefined') {
        this.openZoom(link);
        return;
      }
      if (this.pendingZoom?.link === link) return;
      this.cancelPendingZoom();
      const pending = { link, controller: new AbortController() };
      this.pendingZoom = pending;
      link.setAttribute('aria-busy', 'true');
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.cancelPendingZoom();
      }, { signal: pending.controller.signal });
      const stillRelevant = () => {
        const slide = link.closest('.product-images__slide');
        return this.pendingZoom === pending && this.isConnected && link.isConnected &&
          slide?.classList.contains('is-active') && slide.classList.contains('is-selected');
      };
      this.loadZoomAssets().then(() => {
        if (stillRelevant()) this.openZoom(link);
      }).catch(() => {
        // The original image remains a usable fallback if its current view is still active.
        if (stillRelevant()) window.location.assign(link.href);
      }).finally(() => {
        if (this.pendingZoom === pending) this.cancelPendingZoom();
      });
    }
    openZoom(link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== 'undefined') {
        let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);
        this.activeZoom = pswp;
        this.viewerController?.abort();
        const viewerController = new AbortController();
        this.viewerController = viewerController;
        this.pswpElement.addEventListener('keydown', (event) => {
          if (event.key !== 'Tab') return;
          const controls = Array.from(this.pswpElement.querySelectorAll('button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'))
            .filter((element) => element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
          const index = controls.indexOf(document.activeElement);
          if (!controls.length) {
            event.preventDefault();
            this.pswpElement.focus();
          } else if (event.shiftKey && index <= 0) {
            event.preventDefault();
            controls[controls.length - 1].focus();
          } else if (!event.shiftKey && (index < 0 || index === controls.length - 1)) {
            event.preventDefault();
            controls[0].focus();
          }
        }, { signal: viewerController.signal });
        pswp.listen('destroy', () => {
          viewerController.abort();
          if (this.activeZoom === pswp) this.activeZoom = null;
        });
        // Zoom indexes contain images only, whereas Flickity also contains videos/models.
        const zoomImages = this.activeImages.slice();
        let zoomSelectionChanged = false;
        pswp.listen('close', () => {
          if (!this.isConnected || !this.flkty) return;
          const slide = zoomImages[pswp.getCurrentIndex()]?.closest('.product-images__slide');
          if (!slide?.isConnected || !slide.classList.contains('is-active')) return;
          zoomSelectionChanged = pswp.getCurrentIndex() !== this.pswpOptions.index;
          this.flkty.selectCell('#' + slide.id, false, true);
          this.syncThumbnailState(true);
        });
        // Wait for PhotoSwipe to hide the dialog and remove its focus trap.
        pswp.listen('destroy', () => requestAnimationFrame(() => {
          if (!this.isConnected || this.pswpElement.getAttribute('aria-hidden') !== 'true') return;
          const selectedLink = this.querySelector('.product-images__slide.is-selected .product-single__media-zoom');
          const targets = zoomSelectionChanged ? [selectedLink, link] : [link, selectedLink];
          const target = targets.find((element) => element?.isConnected &&
            !element.closest('[inert], [aria-hidden="true"]') &&
            element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
          target?.focus({ preventScroll: true });
        }));
        pswp.listen('firstUpdate', function () {
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = {
              top: 50,
              bottom: 50
            };
          });
        });
        pswp.init();
      }
    }
  }
  customElements.define('product-slider', ProductSlider);
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      if (this.dataset.initialized === 'true') {
        if (window.CollinoProductAddRecovery.isUncertain(this)) this.showUnconfirmedAdd();
        return;
      }
      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      if (!this.form) return;
      this.dataset.initialized = 'true';
      const variantInput = this.form.querySelector('[name=id]');
      if (variantInput) variantInput.disabled = window.CollinoProductAddRecovery.isUncertain(this);
      if (!this.sticky) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
      this.addEventListener('click', event => {
        if (event.target.closest('[data-product-add-check]')) this.checkUnconfirmedAdd();
      });
      if (window.CollinoProductAddRecovery.isUncertain(this)) this.showUnconfirmedAdd();
    }
    onSubmitHandler(evt) {
      evt.preventDefault();
      if (window.CollinoProductAddRecovery.isUncertain(this)) { this.showUnconfirmedAdd(); return; }
      const purchase = this.closest('[data-product-purchase]');
      if (purchase && purchase.dataset.variantState !== 'ready') return;
      if (this.form.querySelector('input[name="id"]')?.disabled) return;
      if (this.form.querySelector('button[name="add"]')?.disabled) return;

      const cartRedirect = evt.submitter?.matches('[data-cart-redirect]') ? evt.submitter : null;
      if (cartRedirect?.disabled) return;
      const cartUrl = cartRedirect?.value;

      if (!this.validateQuantityInput()) {
        return;
      }

      if (!this.form.reportValidity()) {
        return;
      }

      // Candado contra el doble submit. Ya habia un guard con la misma intencion
      // (el `if (...contains('loading')) return` de abajo) pero estaba adentro del
      // forEach: su return sale del callback, no del handler, asi que el segundo
      // toque se salteaba la decoracion del boton y seguia derecho al fetch.
      // Reproducido: dos toques a 70ms -> item_count 2. aria-disabled tampoco lo
      // frena: solo se lo cuenta a los lectores de pantalla, el boton sigue
      // clickeable. En un producto de $7M, un dedo rapido compraba dos.
      if (this.isSubmitting) return;
      this.isSubmitting = true;

      const submitButtons = [
        ...this.querySelectorAll('.single-add-to-cart-button, [data-cart-redirect]'),
        ...document.querySelectorAll(`product-add-to-cart-sticky[data-section="${this.dataset.section}"] .single-add-to-cart-button`)
      ];

      submitButtons.forEach((submitButton) => {
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();


      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };


      let formData = new FormData(this.form);

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      const enqueue = window.CollinoCart?.enqueue || ((operation) => operation());
      return enqueue(() => this.fetchCartJSON(`${theme.routes.cart_add_url}`, config, 15000)
        .then(async (response) => {
          const data = await response.json();
          const validId = value => ['string', 'number'].includes(typeof value) && /^\d+$/.test(String(value)) && Number(value) > 0;
          const knownRejection = Number.isInteger(Number(data?.status)) && Number(data.status) >= 400 && Number(data.status) < 500;
          const validItems = validId(data?.id) || (Array.isArray(data?.items) && data.items.length > 0 && data.items.every(item => validId(item?.id)));
          if (!data || typeof data !== 'object' || (!knownRejection && !validItems) || Number(data.status) >= 500) throw new Error('Unconfirmed cart response');
          if (!response.ok && !data.status) throw new Error('Cart request failed: ' + response.status);
          return data;
        })
        .then(async (response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            if (response.status === 422) {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                bubbles: true
              }));
            }
            this.handleErrorMessage(response.description || response.message || 'No pudimos agregar esta opción. Revisá la selección e intentá nuevamente.');
            return;
          }

          // El pago por transferencia se elige en el carrito. Navegar sólo
          // después del POST exitoso, sin abrir el drawer ni agregar dos veces.
          try {
            if (!cartUrl) await this.renderContents(response);
          } catch {
            // El POST ya tuvo éxito. Recuperar la vista nunca repite el agregado.
            this.handleErrorMessage('El producto se agregó, pero no pudimos actualizar el panel. Revisá el carrito antes de volver a agregarlo.', { cartLink: true });
          }

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
          if (cartUrl) window.location.assign(cartUrl);
        })
        .catch(async () => {
          // Cancelar la espera no revierte Shopify. Bloquear antes de soltar la cola.
          window.CollinoProductAddRecovery.markUncertain(this);
          document.querySelectorAll('product-form').forEach(form => {
            if (window.CollinoProductAddRecovery.isUncertain(form)) form.showUnconfirmedAdd();
          });
          this.showUnconfirmedAdd();
          await this.checkUnconfirmedAdd();
        })
        .finally(() => {
          // Termina la carga y libera cola; el candado comercial incierto sigue activo.
          this.isSubmitting = false;
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
        }));
    }

    async fetchCartJSON(url, config = {}, timeoutMs = 8000) {
      const controller = new AbortController();
      let timeout;
      const deadline = new Promise((_, reject) => {
        timeout = setTimeout(() => {
          controller.abort();
          reject(new Error('Cart request timed out'));
        }, timeoutMs);
      });
      try {
        const request = fetch(url, { ...config, signal: controller.signal }).then(async response => {
          const data = await response.json();
          return { ok: response.ok, status: response.status, json: async () => data };
        });
        return await Promise.race([request, deadline]);
      } finally { clearTimeout(timeout); }
    }

    showUnconfirmedAdd(message) {
      if (!this.isConnected) return;
      const purchase = this.closest('[data-product-purchase]');
      const input = this.form.querySelector('input[name="id"]');
      if (input) input.disabled = true;
      this.querySelectorAll('.single-add-to-cart-button, [data-cart-redirect]').forEach(button => { button.disabled = true; });
      purchase?.querySelectorAll('[data-dynamic-checkout]').forEach(checkout => {
        checkout.hidden = true;
        checkout.setAttribute('inert', '');
      });
      this.handleErrorMessage(message || 'No pudimos confirmar el agregado. Revisá el carrito; no volveremos a agregar este producto desde esta ficha.', { cartLink: true, recheck: true });
    }

    async checkUnconfirmedAdd() {
      if (!this.isConnected || !window.CollinoProductAddRecovery.isUncertain(this) || this.isCheckingAdd) return;
      this.isCheckingAdd = true;
      const review = this.querySelector('[data-product-add-check]');
      if (review) review.disabled = true;
      try {
        const response = await this.fetchCartJSON(`${theme.routes.cart_url || '/cart'}.js`, { cache: 'no-store' });
        const cart = await response.json();
        if (!response.ok || !Array.isArray(cart?.items)) throw new Error('Invalid cart response');
        const variantId = String(this.form.querySelector('input[name="id"]')?.value || '');
        const containsVariant = cart.items.some(item => String(item.variant_id || item.id) === variantId && Number(item.quantity) > 0);
        this.showUnconfirmedAdd(containsVariant ? 'El carrito contiene esta variante. Revisá la cantidad antes de continuar.' : 'Esta variante todavía no aparece en el carrito. La solicitud anterior puede llegar después; el agregado sigue bloqueado.');
      } catch {
        this.showUnconfirmedAdd('No pudimos consultar el carrito. Podés volver a comprobar o abrirlo; no se enviará otro agregado.');
      } finally {
        this.isCheckingAdd = false;
        if (review) review.disabled = false;
      }
    }

    validateQuantityInput() {
      const quantityInput = this.form?.querySelector('input[name="quantity"]');
      if (!quantityInput) return true;

      const min = parseInt(quantityInput.getAttribute('min'), 10) || 1;
      const maxAttr = quantityInput.getAttribute('max');
      const max = maxAttr ? parseInt(maxAttr, 10) : Infinity;
      const step = parseInt(quantityInput.getAttribute('step'), 10) || 1;
      const value = Number(quantityInput.value);
      const roundedValue = Math.round(value);
      let message = '';

      if (!Number.isFinite(value)) {
        message = 'Ingresá una cantidad válida.';
        quantityInput.value = min;
      } else if (roundedValue < min) {
        message = `La cantidad mínima es ${min}.`;
        quantityInput.value = min;
      } else if (roundedValue > max) {
        message = `La cantidad máxima disponible es ${max}.`;
        quantityInput.value = max;
      } else if ((roundedValue - min) % step !== 0) {
        message = `La cantidad debe avanzar de ${step} en ${step}.`;
        quantityInput.value = min;
      } else if (String(roundedValue) !== quantityInput.value) {
        quantityInput.value = roundedValue;
      }

      if (!message) {
        quantityInput.setCustomValidity('');
        return true;
      }

      quantityInput.setCustomValidity(message);
      quantityInput.reportValidity();
      this.handleErrorMessage(message);
      quantityInput.focus();
      quantityInput.setCustomValidity('');
      return false;
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-count'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-secondary-area--item-amount'
      }];
    }
    async renderContents(parsedState) {
      const targets = this.getSectionsToRender().filter(section => document.getElementById(section.id));
      const updatesFrom = sections => targets.map(section => ({
        target: document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id),
        html: sections?.[section.section] ? this.getSectionInnerHTML(sections[section.section], section.selector) : null
      }));
      let updates = updatesFrom(parsedState.sections);
      if (updates.some(update => update.html == null)) {
        // Lectura segura dentro de la misma operación de cola; no encolar otra escritura.
        const url = new URL(window.location.href);
        url.searchParams.set('sections', [...new Set(targets.map(section => section.section))].join(','));
        const response = await this.fetchCartJSON(url.toString(), { cache: 'no-store' }, 15000);
        if (!response.ok) throw new Error('Cart sections unavailable');
        updates = updatesFrom(await response.json());
        if (updates.some(update => update.html == null)) throw new Error('Incomplete cart sections');
      }
      updates.forEach(update => { update.target.innerHTML = update.html; });
      const productDrawer = document.getElementById('Product-Modal');
      if (productDrawer && productDrawer.contains(this)) productDrawer.hide();
      const cartDrawer = document.getElementById('Cart-Drawer');
      if (cartDrawer) {
        cartDrawer.open();
        cartDrawer.removeProductEvent();
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector)?.innerHTML;
    }
    handleErrorMessage(errorMessage = false, { cartLink = false, recheck = false } = {}) {
      if (this.hideErrors && !recheck) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      if (!this.errorMessage) return;
      const cart = this.errorMessageWrapper.querySelector('[data-product-feedback-cart]');
      if (cart) cart.hidden = !cartLink;
      const review = this.errorMessageWrapper.querySelector('[data-product-add-check]');
      if (review) review.hidden = !recheck;

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = typeof errorMessage === 'string' ? errorMessage : 'No pudimos agregar esta opción. Revisá la selección e intentá nuevamente.';
        this.errorMessageWrapper.focus({ preventScroll: true });
        const bounds = this.errorMessageWrapper.getBoundingClientRect();
        if (bounds.top < 120 || bounds.bottom > window.innerHeight) this.errorMessageWrapper.scrollIntoView({ block: 'center', behavior: 'auto' });
      }
    }
  });
}


if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
      this.setupObservers();
    }
    setupObservers() {
      const _this = this;
      const form = document.getElementById(`product-form-${this.dataset.section}`);
      const footer = document.getElementById('footer');
      if (!form || !footer) return;
      _this.formPassed = false;

      // Se calcula por geometria en vez de depender de que el IntersectionObserver
      // dispare. El observer solo corre al CRUZAR un threshold, y con [0, 1] hay un
      // caso que nunca cruza: si el form arranca DEBAJO del viewport (ratio 0) y el
      // usuario salta el scroll de una -restauracion al volver atras, link con
      // ancla-, termina ARRIBA del viewport (ratio 0 otra vez). Ningun cruce, ningun
      // callback, y la barra no aparecia nunca. Verificado: scrollTo(0, 1600) desde
      // 0 -> no aparece; bajando por pasos -> aparece.
      //
      // La condicion es la misma de antes, escrita directo: la barra se ve si el
      // form ya quedo arriba y el footer todavia no entro.
      const evaluate = () => {
        const formRect = form.getBoundingClientRect();
        const footerRect = footer.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        _this.formPassed = formRect.bottom <= 0;
        const show = _this.formPassed && footerRect.top >= vh;
        _this.classList.toggle('sticky--visible', show);
        // Espejo en <body> para poder ocultar la pestana de WhatsApp y el banner de
        // sugerencia de tienda cuando la barra esta visible, sin depender de :has().
        document.body.classList.toggle('atc-sticky-visible', show);
      };

      let ticking = false;
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(() => {
          ticking = false;
          evaluate();
        });
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      // Estado inicial: cubre la carga con scroll ya restaurado, que es justo el
      // caso que el observer se perdia.
      evaluate();
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}
